'use strict';

var Transport = require('../transport');
var object = require('../object');

var getRequestData = function(category, action, opt_label, opt_data, opt_post_data, opt_options) {
  var label = null;
  var data = opt_data;
  var options = null;

  if (opt_label && typeof opt_label === 'object') {
    data = opt_label;
    options = opt_data;
  } else {
    label = opt_label || null;
    options = opt_options || null;
  }

  var request = {
    category: category,
    action: action
  };

  if (label) {
    request.label = label;
  }

  if (data && typeof data === 'object') {
    request.data = object.assign({}, data);
  }

  if (options && typeof options === 'object') {
    for (var name in options) {
      if (options.hasOwnProperty(name)) {
        request[name] = options[name];
      }
    }
  }

  return request;
};

module.exports = function(funnel) {
  var transport = new Transport('/event');

  return function(category, action, opt_label, opt_data, opt_post_data, opt_options) {
    var force = opt_options && opt_options.force;

    if (opt_label && typeof opt_label === 'object') {
      force = opt_data && opt_data.force;
    }

    if (funnel._funnelWasSent || force) {
      var req = getRequestData(category, action, opt_label, opt_data, opt_post_data, opt_options);

      funnel.addRelations(req);
      transport.debug = funnel.isDebug();

      transport.send(req, opt_post_data);
    } else {
      funnel._preSendQueue.push({
        type: 'event',
        category: category,
        action: action,
        opt_label: opt_label,
        opt_data: opt_data,
        opt_post_data: opt_post_data,
        opt_options: opt_options
      });
    }
  };
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/trackevent.js
// module id = 27
// module chunks = 1 3